/**
 * User: nir
 * Date: 06/09/2016
 * Time: 17:39
 */

window.jQuery(function ($) {
    function isInternalLink(index, element) {
        var url = $(element).attr('href');

        if (!url || typeof url === typeof undefined || url.length === 0)
            return false;

        return /^https?:\/\/(the)?culturetrip\.com/i.test(url);
    }

    $(window).load(function () {
        jQuery('[data-js="preloader"]').remove();
        jQuery('[data-transparent]').removeAttr('data-transparent');

        $('[data-type="article-content"] a')
            .not(isInternalLink)
            .addClass("external")
            .attr({target: "_blank"});
    });
});